// eslint-disable-next-line import/prefer-default-export
export enum CallNetworkQuality {
  NONE = 1,
  BAD = 2,
  NORMAL = 3,
  EXCELENT = 4,
}
